module.exports = __webpack_public_path__ + "media/customizations/vanmetre/back-f5f0934c253199d645e47ca6b16d4ebb.jpg";